import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useViewerLeaderInsightsAccess } from '@/auth/useViewerLeaderInsightsAccess';
import { RoutesEnum } from '@/enums';

export const LeaderInsightsGuard = ({ children }: PropsWithChildren<unknown>) => {
  const { canAccessLeaderInsights, isLeaderInsightsAccessResolved } =
    useViewerLeaderInsightsAccess();

  if (!isLeaderInsightsAccessResolved) {
    return null;
  }

  if (!canAccessLeaderInsights) {
    return <Navigate to={RoutesEnum.DAILY_SURVEY_OVERVIEW} replace />;
  }

  return <>{children}</>;
};
